import { ChangeDetectorRef, Injectable, OnChanges, SimpleChanges } from "@angular/core";
import { ValueAccessorComponent } from "../base/Input.component";

@Injectable()
export abstract class SelectorBase<T, TY> extends ValueAccessorComponent<T> implements OnChanges {

  entities: TY[];
  loading: boolean = false;
  nombreEntidad: string = "";

  constructor(protected ref: ChangeDetectorRef, nombreEntidad: string){
    super();
    this.nombreEntidad = nombreEntidad;
  }

  ngOnChanges(changes: SimpleChanges): void {
    //this.ref.detectChanges();
  }

  enableDetectChanges() {
    this.ref.detectChanges();
    this.ref.reattach();
  }

  disableDetectChanges() {
    this.ref.detach();
  }
  safeOnLocalStorage() {
    localStorage.setItem(this.getKeyLocalstorage(), JSON.stringify(this.entities));
  }

  getFromLocalStorage() {
    const entities = localStorage.getItem(this.getKeyLocalstorage());
    if (entities) {
      try {
        this.entities = JSON.parse(entities);
        this.loading = false;
      } catch (error) {
        console.error(error);
        console.error(`No se pudo obtener los ${this.nombreEntidad} desde la caché`);
      }
    }
  }

  abstract getKeyLocalstorage(): string;

}
